import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { ProfilingData } from "./ProfilingData";

export class ProfilingSet {
    data: OrdinaryObject<ProfilingData>;
}
